import { TError, TGroupedAppsResponse } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import { getSession } from '../auth';
import axios from '../axios';
import { APP_SETTINGS_GC_TIME, APP_SETTINGS_STALE_TIME, GROUPED_APPS_ENTITY } from './entity';

export const getGroupedAppsQueryKey = () => [GROUPED_APPS_ENTITY];

export const useGetGroupedAppsQuery = () => {
  const token = getSession();

  return useQuery<TGroupedAppsResponse, TError>({
    queryKey: getGroupedAppsQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TGroupedAppsResponse>(GROUPED_APPS_ENTITY);
      return res.data;
    },
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: APP_SETTINGS_STALE_TIME,
    gcTime: APP_SETTINGS_GC_TIME,
  });
};
